import React from 'react';
import Relay from 'react-relay';

class UserDashboard extends React.Component {

    constructor(props) {
        super(props);
    }

    calculateStats(users) {
        let connexions = [];

        users.forEach(user => {
            let date = 0 ;
            if (user.node.lastConnexionDate) date = new Date(user.node.lastConnexionDate).getTime();
            if (date == 0 || date < new Date() - 7 * 24 * 3600 * 1000) date = "Before last week";
            else date = "Last week";
            connexions.push(date);
        });

        let counts = {};

        for(var i = 0; i< connexions.length; i++) {
            var num = connexions[i];
            counts[num] = counts[num] ? counts[num]+1 : 1;
        }

        let tab = [];

        for (var count in counts) {
            let percentage = Math.round(counts[count] * 100 / connexions.length);
            tab.push([count, counts[count],percentage]);
        }

        return tab;
    }

    render() {
        let users = this.props.viewer.users.edges ;

        let stats = this.calculateStats(users);

        return (
            <div className="container" style={{marginTop:20}}>
                <table className="table table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Active</th>
                            <th>Nb of users</th>
                            <th>%</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            stats.map((stat,index) => {
                                return (<tr key={index}><td>{stat[0]}</td><td>{stat[1]}</td><td>{stat[2]}</td></tr>)
                            }
                        )}
                    </tbody>
                </table>
            </div>            
        )

    }
}



UserDashboard.propTypes = ({
  children: React.PropTypes.node,
});

export default Relay.createContainer(UserDashboard, {
  fragments: {
    viewer: () => Relay.QL`
    fragment on Viewer { 
        users (last:1000) {
            edges {
                node {
                    lastConnexionDate
                }
            }
        }
    }`,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Dashboard/UsersDashboard.js